import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../../../gd-components/gd-popover/popover";
// @ts-ignore
import DatepickerContent from "../../../../../../../gd-components/datetime/datepicker/datepicker-content";
// import {Column} from "../../../../../../../gd-modules/manager/columns/types";
import ItemModel from "../../../../../../../model2/item/item-model";
import ProjectTaskTableManager from "../../../../../../../../app/project/table/manager/project-task-table-manager";
import Moment from "moment/moment";
import {SCHEDULE_SOMEDAY} from "../../schedule";

const debug = "FieldTaskEndDate_Popover"
// const debug = "false"

type Props = {
    // column   : Column
    field    : any
    // listItem : ItemModel
    manager  : ProjectTaskTableManager
    parent   : any
    value    : any
}

export default function FieldTaskSchedule_Popover(props: Props) {

    debug && console.log(debug, "render",  props)

    const onSelect = (date:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(date);
    };

    const scheduleToSomeday = () => {
        onSelect(SCHEDULE_SOMEDAY)
        // props.manager.setSchedule(props.listItem.id, null, 2)
        // gd.api.Task.scheduleSomeday(props.listItem.item.id)
        // props.parent.hidePopover();
    }

    const value = props.value
    const minDate = Moment()

    return (
        <Popover attachment="top center"
                 targetAttachment="bottom center"
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <DatepickerContent value        = {value}
                               onSelect     = {onSelect}
                               minDate      = {minDate}
                               onSelectSomeday={scheduleToSomeday}
                               btnToday     = {true}
                               btnTomorrow  = {true}
                               btnSomeday   = {true}
            />
        </Popover>
    );
}
